import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {ButtonSpinner} from '../../styles/components/button.style';

export const Wrapper = styled.div`
  display: flex;
  align-self: stretch;
  flex-direction: column;
  width: ${p => p.theme.meal.width};
  padding: ${p => p.theme.meal.padding};
  position: relative;
  font-family: ${p => p.theme.meal.fontFamily};
  ${media.small`
    width: 100%;
  `};
`;

export const MealStyled = styled.div`
  font-size: ${props => props.theme.fontSize};
  padding: ${props => props.theme.padding};
  background-size: cover;
  background-color: ${p => p.compact ? p.theme.primaryBackground : p.theme.compactMeal.backgroundColor};
  color: ${props => props.theme.quaternaryColor};
  cursor: pointer;
  border-bottom: ${p => p.theme.meal.border};
  display: flex;
  flex-grow: 1;
  align-self: stretch;
  flex-direction: column;
  &:hover {
    background-color: ${props => props.theme.secondaryBackground};
    color: ${props => props.theme.primaryColor};
  }
`;

export const MealHeader = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const MealName = styled.span`
  display: flex;
  align-items: flex-start;
  color: ${props => props.theme.quinaryColor};
  font-size: ${props => props.theme.meal.name.fontSize};
  flex-grow: 2;
`;

export const Name = styled.span`
  padding-right: ${props => props.theme.padding};
  font-size: ${props => props.theme.meal.name.fontSize};
  font-weight: bold;
  &:hover {
    color: ${props => props.theme.tertiaryColor};
  }
`;

export const MealIconWrapper = styled.div`
  display: ${p => p.theme.meal.arrow.display};
  flex-shrink: 0;
  height: 2.4rem;
  &:hover img, &:hover div {
    opacity: 1;
  }
`;

export const Footer = styled.div`
  overflow: hidden;
  background-color: ${p => p.theme.primaryColor};
  display: ${p => p.theme.meal.footer.display};
  height: ${p => p.theme.meal.footer.height};
  background-size: cover;
  position: relative;
  width: 100%;
  cursor: pointer;
  align-items: center;
`;

export const MealPic = styled.img`
  width: 100%;
`;

export const MealIcon = styled.img`
  width: 2.4rem;
  margin-right: 0.4rem;
  opacity: 0.31;
`;

export const Arrow = styled.div `
  width: 0;
  height: 0;
  opacity: 0.31;
  display: inline-block;
  margin-bottom: 0.4rem;
  border-top: 0.8rem solid ${props => props.open ? '#000' : 'transparent'};
  border-right: ${props => !props.open ? 'none' : '0.8rem solid transparent'};
  border-bottom: ${props => props.open ? 'none' : '0.8rem solid transparent'};
  border-left: 0.8rem solid ${props => !props.open ? '#000' : 'transparent'};
`;

export const Description = styled.span`
  color: ${props => props.theme.quaternaryColor};
  font-size: ${props => props.theme.meal.description.fontSize};
  line-height: ${props => props.theme.meal.description.lineHeight};
  padding-top: ${props => props.theme.padding};
`;

export const PriceStyled = styled.span`
  color: ${props => props.theme.meal.price.color};
  font-size: ${props => props.theme.meal.price.fontSize};
  padding-right: ${props => props.theme.padding};
  font-weight: bold;
`;

export const AddMeal = styled.span`
  display: ${p => p.theme.meal.addToBasket.display};
  color: ${p => p.theme.primaryColor};
  background-color: ${p => p.isDisabled ? p.theme.disabledButtonBackground : p.theme.tertiaryColor};
  font-size: ${p => p.theme.meal.addToBasket.fontSize};
  line-height: ${p => p.theme.lineHeight};
  padding: ${p => p.theme.meal.addToBasket.padding};
  min-width: ${p => p.theme.meal.addToBasket.width};
  text-transform: uppercase;
  white-space: nowrap;
  text-align: center;
  cursor: pointer;
`;

export const AddMealLight = styled(AddMeal)`
  display: block;
  right: 1.5rem;
  bottom: 1.5rem;
  position: absolute;
  text-transform: capitalize;
  padding: 0.2rem 2rem;
  border-radius: 0.4rem;
  border: ${p => `${p.theme.primaryColor} 0.1rem solid`};
  background-color: ${p => p.isDisabled ? p.theme.disabledButtonBackground : p.theme.secondaryColor};
`;

export const Spinner = ButtonSpinner.extend`
  height: 1.4rem;
  width: 1.4rem;
  border-top: 0.3rem solid ${props => props.greySpinner ? '#e5e5e5' : props.theme.spinner.c1};
  border-right: 0.3rem solid ${props => props.greySpinner ? '#d1d1d1' : props.theme.spinner.c2};
  border-bottom: 0.3rem solid ${props => props.greySpinner ? '#b2b2b2' : props.theme.spinner.c3};
  border-left: 0.3rem solid ${props => props.greySpinner ? '#9b9b9b' : props.theme.spinner.c4};
`;

export const SpinnerContainer = styled.div`
  display: flex;
  height: 2.4rem;
  justify-content: center;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./components/Meal/Meal.style.js